<template>
  <div>
    <label for="department" class="font-lato mb-2 text-lg text-ng800">{{ $t("contact-with") }}</label>
    <HeadlessListbox v-model="value" name="department" v-slot="{ open }">
      <div class="relative mt-1">
        <HeadlessListboxButton
          class="relative block min-h-[46px] w-full overflow-hidden rounded-sm border border-ng10 bg-transparent px-4 py-3 pr-16 text-left text-base leading-[1.2] text-ng800 transition duration-200 ease-out focus:outline-none focus-visible:border-[#8AA678] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#8AA678] laptop:min-h-[56px] laptop:py-[17px]"
          :class="{
            'border-[#8AA678] ring-1 ring-[#8AA678]': open,
          }"
          arial-label="Recipient"
        >
          <span class="block truncate">{{ value?.name }}</span>
          <span
            class="pointer-events-none absolute inset-y-0 right-0 flex w-[60px] items-center justify-center bg-[#F5FCF1] shadow-subscribe"
          >
            <DownArrow :rotate="open" icon="ep:arrow-down" size="28" />
          </span>
        </HeadlessListboxButton>

        <DropdownTransition>
          <HeadlessListboxOptions
            class="sm:text-sm absolute mt-1 max-h-64 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-dropdown ring-1 ring-black ring-opacity-5 focus:outline-none"
          >
            <HeadlessListboxOption
              v-slot="{ active, selected }"
              v-for="option in props.options"
              :key="option.id"
              :value="option"
              as="template"
            >
              <li
                :class="[
                  active ? 'bg-[#F5FCF1] ' : 'text-gray-900',
                  'relative cursor-pointer select-none py-2 pl-10 pr-4',
                ]"
              >
                <span :class="[selected ? 'font-medium text-[#8AA678]' : 'font-normal', 'block truncate']">{{
                  option.name
                }}</span>
                <span
                  v-if="selected"
                  class="text-amber-600 absolute inset-y-0 left-0 flex items-center pl-2 text-[#8AA678]"
                >
                  <Icon name="ic:round-check" size="28" />
                </span>
              </li>
            </HeadlessListboxOption>
          </HeadlessListboxOptions>
        </DropdownTransition>
      </div>
    </HeadlessListbox>
  </div>
</template>
<script setup lang="ts">
const { t: $t } = useI18n();

const props = defineProps<{
  options: { id: number; name: string }[];
  value: { id: number; name: string } | string;
}>();

const emit = defineEmits(["update:value"]);

const value = computed({
  get: () => props.value,
  set: (value) => emit("update:value", value),
});
</script>
<style lang="scss" scoped></style>
